import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { LanguageStorageService, ProfileService } from 'library-explorer';
import { Observable } from 'rxjs';

@Injectable()
export class AcceptLanguageInterceptor implements HttpInterceptor {

  constructor(
    private readonly languageStorageService: LanguageStorageService,
    private readonly profileService: ProfileService,
    private readonly translateService: TranslateService) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const contentLanguages = this.languageStorageService.getContentLanguages();
    const interfaceLanguage = this.translateService.currentLang;
    const contentLanguage = this.profileService.getCurrentProfileValue()?.contentLanguage;

    const acceptLanguage = (contentLanguages?.length && contentLanguage)
      ? contentLanguage
      : interfaceLanguage;

    request = request.clone({
      setHeaders: {
        'Accept-Language': acceptLanguage || 'en'
      }
    });

    return next.handle(request);
  }
}
